import { LocalizedDateFromUtc, LocalizedDayNameFromUtc } from '@mews-commander/ui';
import { Typography, Stack } from '@optimus-web/core';

interface Props {
    utc: string;
}
export const TimeUnitCell = ({ utc }: Props) => (
    <Stack vertical>
        <Typography textStyle="bodySmallStrong" as="div">
            <LocalizedDayNameFromUtc utcString={utc} />
        </Typography>

        <Typography textStyle="bodySmall" variant="secondary" whiteSpace="nowrap" as="div">
            <LocalizedDateFromUtc utcString={utc} />
        </Typography>
    </Stack>
);
